import { render, staticRenderFns } from "./barang.vue?vue&type=template&id=3901d9df&"
import script from "./barang.vue?vue&type=script&lang=js&"
export * from "./barang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports